import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../context/user.context";
import {
  getFirstAllowedRoute,
  isRouteAllowed,
} from "../../../utils/routing/routePermissions";

export const useNavBarCommon = () => {
  const {
    currentUser,
    requestSignOut,
    beginUnitSelection,
    availableWorkspaces,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    // Con varios tipos de usuario se pregunta primero (cambiar de usuario o
    // cerrar sesión); con uno solo cierra sesión directamente.
    requestSignOut();
  };

  const handleNavigate = (path) => {
    if (isRouteAllowed(path, currentUser)) {
      navigate(path);
      return;
    }
    navigate(getFirstAllowedRoute(currentUser) || "/access-denied", {
      replace: true,
    });
  };

  const isActive = (path) => location.pathname === path;

  return {
    currentUser,
    navigate,
    location,
    handleLogout,
    handleNavigate,
    isActive,
    beginUnitSelection,
    canChangeWorkspace: availableWorkspaces.length > 1,
  };
};
